import { createAction } from '@lingoda/core';

export default createAction('booking/ASYNC_MIN_DATE');
